import { render, staticRenderFns } from "./RevenuesPage.vue?vue&type=template&id=35028120"
import script from "./RevenuesPage.vue?vue&type=script&lang=ts"
export * from "./RevenuesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports